<template>
  <div v-if="myAllProduct && myAllProduct.length > 0">
    <div class="col-12" style="border-bottom: 1px solid rgba(148, 148, 148, 0.5);margin: 20px 0;">
      <h3 style="font-weight: bold;">สินค้าอื่นๆ</h3>
    </div>
    <div class="subImage">
      <span v-for="(product , n) in myAllProduct.filter(d => !d.get('isSubProduct'))" :key="n">
        <div class="box-product-item" v-if="currentProduct != product.id">
          <div class="item">
            <div style="padding: 10px;">
              <a :href="`/productDetail/${product.id}`">
                <img :src="product.get('images')[0]._url">
                <p class="name ">{{product.get('name')}}</p>
                <p class="price" v-if="product.get('price')" :style="`${product.get('fullPrice') ? 'font-size: 22px;' : 'font-size: 20px;'}`">
                  <small style="text-decoration: line-through;font-size:13px;color: #858585;">฿{{eArabic(product.get('fullPrice') )}}</small>
                  ฿{{eArabic(product.get('price'))}}<small style="font-size:13px;color: #858585;">/{{product.get('productCode') == 'CID' ? 'เครื่อง' : product.get('unitType')}}</small>
                </p>
                <div class="viwe-detail" v-else>
                  <p>ดูรายละเอียดเพิ่มเติม</p>
                  <i class="fa fa-angle-right"></i>
                  <i class="fa fa-angle-right"></i>
                </div>
              </a>
              <div  v-if="product.get('price') && !product.get('isSoldOut')" class="add-cart" @click="addCart(product)">เพิ่มสินค้า</div>
              <div  v-if="product.get('price') && product.get('isSoldOut')" class="add-cart sold-out">สินค้าหมด</div>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>
</template>
<script>
import store from '../store'
import { mapState } from 'vuex'
export default {
  props:['currentProduct'],
  data(){
    return{
      page:0,
      myAllProduct: ""
    }
  },
  async mounted(){
      this.myAllProduct = _.sortBy(this.allProduct , (p) =>{
        return p.viewerCounter
      }).reverse();
  },
  methods:{
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    async addCart(product){

      // ------------------------mixpanel---------------------------
      if(this.user) this.$mixpanel.track(`click-add-cart`, {from: "productdetail-carousel", product: this.product.id , id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
      else this.$mixpanel.track(`click-add-cart`, {from: "productdetail-carousel", product: this.product.id})
      // -----------------------------------------------------------

      let objCart = {
          productId: product.id,
          number: 1
        }

        if(localStorage.getItem('carts')){
          if(JSON.parse(localStorage.getItem('carts')).findIndex(item => item.productId === product.id) <= -1){
            let carts = JSON.parse(localStorage.getItem('carts'))
            let balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStore",{productId : product.id});

            carts.push(objCart)

            localStorage.setItem('carts',JSON.stringify(carts))
            store.commit('setCarts', carts)
            store.commit('addHashBalanceProduct', balanceStore)
          }
        }else{
          localStorage.setItem('carts',JSON.stringify([objCart]))
          store.commit('setCarts', [objCart])
        }
        $("#addCartToast").addClass('show')
        $("#addCartToast").removeClass('hide')

        setTimeout(function(){
          $("#addCartToast").removeClass('show')
          $("#addCartToast").addClass('hide')

        },2000)
    }
  },
  computed: {
    ...mapState([
      'allProduct',
      'user'
    ])
  },
}
</script>
<style scoped>
*{
  color: rgb(80, 80, 80);
}
a{
  color: black;
  text-decoration: none;
}
img{
  width: 100%;
  height: auto;
}
.subImage{
  margin-top: 10px;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  overflow-x: scroll;
  white-space: nowrap;
  position: relative;
}
.name{
  display: block;
  white-space: normal;
  min-height: 48px;
  text-align: center;
}
.box-product-item{
  padding: 15px;
  width: 300px;
  display: inline-block;
  vertical-align: top;
  transition: all 300ms;
}
.box-product-item .item {
  border: 1px solid rgba(148, 148, 148, 0.5);
  border-radius: 15px;

}
.box-product-item p {
  padding: 0;
  margin: 0;
}
.box-product-item .item .price{
  color: #e9773b;
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 0;
}
.box-product-item:hover {
  opacity: .8;
  transform: scale(1.01);
  
}
.box-product-item:hover .item{
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
}
.add-cart{
  margin-top: 10px;
  background: #e9773b;
  color: white;
  width: 100%;
  padding: 8px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: bold;
  transition: all 300ms;
  border: 1px solid #e9773b;
  text-align: center;
}
.add-cart:hover:not(.sold-out){
  /* background: #da6d33; */
  background-color: white;
  color: #e9773b;
}
.add-cart.sold-out{
  cursor: default;
  background: white;
  border: 1px solid rgb(148, 148, 148);
  color: rgb(148, 148, 148);
}
.viwe-detail {
  /* border: 1px solid black; */
  position: relative;
  margin-top: 20px;
  text-align: center;
  margin-bottom: 28px;
}
.viwe-detail p {
  margin: 0;
  display: inline;
  color: rgb(224, 134, 85);
  padding-top: -20px;
}
.viwe-detail i {
  position: relative;
  top: 6px;
  left: 6px;
  font-size: 33px;
}
.viwe-detail i{
  color: rgba(231, 138, 88, 0.644);
  margin-right: -7px;
}
.viwe-detail i:nth-child(3){
  color: rgba(233, 119, 59, 0.9);
  margin-right: -7px;
}
</style>